import { FormikProps } from 'formik'
import { useRef } from 'react'
import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { AgGridTable } from '../../../utils/agGridTable/AgGridTable'
import { Button } from '../../../utils/Button'
import ArrayInput from '../../../utils/form/ArrayInput'
import { propsInterfaceFormGroupInput } from '../../../utils/form/FormGroupInput'
import { BTCreateContract3 } from '../BTContract/BTCreateContract3'
import { BTCreateContract4 } from '../BTContract/BTCreateContract4'
import { useBetween } from 'use-between'
import { BTCreateContract2 } from '../BTContract/BTCreateContract2'
import { ActionDataGrid2 } from './ActionDataGrid2'
import { callSP } from '../../../../setup/axios/AxiosCallSP'
import { warn, error } from '../../../utils/customToasd'
import { editStepGrid, getPlateTypesLevels, isValid } from './step.service'
import { AgGridTable2 } from 'app/utils/agGridTable/AgGridTable2'
import { ObjectModal } from 'app/utils/modal/ObjectModal'
import { AlertModalProps } from 'app/utils/modal/AlertModal'
import { getLStorage, setLStorage, setSStorage, getSStorage } from 'global.d'
import { useLocation, useNavigate } from 'react-router-dom'

const StepContract2: FC<StepContract2Props> = (props) => {
  const location = useLocation()
  const [alertModal, setAlertModal] = useState<AlertModalProps>()
  const [showChangeStructure, setShowChangeStructure] = useState(false)
  const { setDataRow3, dataRow3 } = useBetween(BTCreateContract3)
  const { setDataRow4, dataRow4 } = useBetween(BTCreateContract4)
  const { setDataRow2, dataRow2 } = useBetween(BTCreateContract2)
  const [addRow, setAddRow] = useState(false)
  const [open, setOpen] = useState(false)
  const [alertChangeStructure, setAlertChangeStructure] = useState(false)
  const [estructuras, setEstructuras] = useState<any>([])
  const [filterPlateTypes, setFilterPlateTypes] = useState<any[]>([])
  const [grupoEstructuras, setGrupoEstructuras] = useState<any[]>([])
  // const [categoriaDieteticaRec, setCategoriaDieteticaRec] = useState<any>()
  const [btnStructure, setBtnStructure] = useState(props.title)
  const [idGridEdit, setIdGridEdit] = useState()
  const [idStructure, setIdStructure] = useState()
  const [idFatherStructure, setIdFatherStructure] = useState()
  const columInput = 4
  const [gridRef, setGridRef] = useState<any>()
  const [disabledInput, setDisabledInput] = useState(false)
  const isLoadingEditRef = useRef(false)
  const [canEditStructure, setCanEditStructure] = useState(true)
  const [arrayInput, setArrayInput] = useState<propsInterfaceFormGroupInput[]>([])
  const [columnDefs] = useState([
    { field: 'fatherStructure', headerName: 'Estructura Padre', minWidth: 180, rowDrag: true },
    { field: 'id', hide: true },
    { field: 'structure', headerName: 'Estructura', minWidth: 150 },
    { field: 'plateType', headerName: 'Tipo de Plato', minWidth: 180 },
    { field: 'dietaryCategory', headerName: 'Categoría Dietética', minWidth: 180, hide: true },
    { field: 'dietaryCategoryAll', headerName: 'Categoría Dietética', minWidth: 240 },
    { field: 'tolerance', headerName: 'Intolerancia', minWidth: 150 },
    { field: 'allergens', headerName: 'Permite Alergenos', minWidth: 180 },
    // { field: 'allowsStamp', headerName: 'Permite sellos', minWidth: 150 },
    { field: 'blockedDays', headerName: 'Días Bloqueados', minWidth: 180 },
    {
      field: 'Acción',
      minWidth: 150,
      cellRenderer: (params: any) => {
        return <>
          {editStepGrid(params, callbackEdit)}
          {props.estate.plantilla > 0 ? "" : <ActionDataGrid2 dataRow={params.node.data} />}
        </>;
      },
      cellEditor: 'agRichSelectCellEditor',
      cellEditorPopup: true,
    },
  ])
  useEffect(() => {
    setLStorage("structure", "");

    const state: any = location.state
    if (state?.params) {
      const contract = {
        ...state?.params,
        id: state?.contrato,
      }
      if (contract?.plantilla > 0 || contract?.minuta > 0) {
        setDisabledInput(true)
        setCanEditStructure(false)
      } else {
        setCanEditStructure(true)
      }
    }

  }, [])
  const callbackEdit = useCallback(
    (data: any) => {
      setIdGridEdit(data.id)
      setIdStructure(data.idStructure)
      setIdFatherStructure(data.idFatherStructure)
      formStep2(true, data)
    },
    [arrayInput]
  )

  const getGrupoEstr = async (serv: number) => {
    props.setLoad(true)
    try {
      const dataResp: any = await callSP('amd_getGrupoEstructura', [
        { text: 'servicio', value: serv.toString() },
      ])
      let arr: any[]
      const resp: any = dataResp.data
      if (resp.status == '200') {
        arr = resp.result.map((e: any) => {
          return {
            ...e,
            text: e.tipo_estructura,
            value: e.id_grupo_estructura.toString(),
          }
        })
        setGrupoEstructuras(arr)
      }
      props.setLoad(false)
    } catch (e: any) {
      error(e)
      props.setLoad(false)
    }
  }

  useEffect(() => {
    if (props.reloadStep2) {
      const serviceStep1 = props.formikProps?.values.service
      if (serviceStep1 && serviceStep1.length) {
        getGrupoEstr(serviceStep1[0].value)
      }
    }
  }, [props.reloadStep2])

  const v = props.formikProps?.values
  useEffect(() => {
    if (props.isReady) {
      formStep2(false)
    }
  }, [
    props.isReady,
    estructuras,
    grupoEstructuras,
    v?.templateType?.[0]?.value,
    v?.monday,
    v?.tuesday,
    v?.wednesday,
    v?.thursday,
    v?.friday,
    v?.saturday,
    v?.sunday,
  ])

  const formStep2 = async (loadData: boolean, data?: any) => {
    const propCat = props.data.categoriaDieteticaRec
    // assignObjectPaths(propCat)
    // setCategoriaDieteticaRec(propCat)
    let hideInput = true
    let dias: any[] = []
    if (
      props.formikProps?.values.templateType &&
      props.formikProps?.values.templateType.length &&
      props.formikProps?.values.templateType[0].value === 2
    ) {
      hideInput = true
    }
    if (
      props.formikProps?.values.templateType &&
      props.formikProps?.values.templateType.length &&
      props.formikProps?.values.templateType[0].value !== 2
    ) {
      hideInput = false
      dias = onDaysSelected()
    }
    // Cuando se edita una estructura existente y templateType no está en formik values,
    // mostrar Días Bloqueados por defecto (solo ocultarlo si explícitamente es Fija)
    if (loadData && hideInput) {
      const tt = props.formikProps?.values.templateType
      const isFija = tt && tt.length && tt[0].value === 2
      if (!isFija) {
        hideInput = false
        dias = onDaysSelected()
      }
    }

    setArrayInput([
      {
        columInput: columInput,
        campo: 'fatherStructure',
        label: 'Grupo estructura',
        type: 'autocomplete',
        disabled: disabledInput,
        advanceOptions: {
          id: 'fatherStructure',
          multiple: false,
          placeholder: 'Ingrese Grupo Estructura',
          options: grupoEstructuras,
        },
        onChange: async (event: any, setFieldValue: any, values: any) => {
          // Saltar durante carga programática de edición (click en lápiz)
          if (isLoadingEditRef.current) return
          props.setLoad(true)
          const group = values.fatherStructure[0]
          if (group?.value && group?.value != '') {
            try {
              const resp: any = await getEstructuras(group.value.toString())
              props.setLoad(false)
            } catch (e: any) {
              error(e)
              props.setLoad(false)
            }
          } else {
            props.setLoad(false)
          }
        },
        className: 'form-control form-control-lg step-2  input-contract',
      },
      {
        columInput: columInput,
        campo: 'structure',
        label: 'Ingrese Estructura',
        type: 'autocomplete',
        disabled: disabledInput,
        advanceOptions: {
          id: 'structure',
          placeholder: 'Ingrese Estructura',
          multiple: false,
          options: estructuras,
        },
        onChange: async (event: React.ChangeEvent<HTMLInputElement>, setFieldValue: any, arrayInput: any) => {
          const dataStructure = await getLStorage("structure")
          if (btnStructure === 'Editar estructura' && props.editContract && dataStructure !== "") {
            const data: any = JSON.parse(dataStructure)
            if (props.formikProps?.values.structure[0].text !== data[0].text && props.formikProps?.values.structure[0].text !== "") {
              setShowChangeStructure(true);
            }
          } else {
            setAlertChangeStructure(false);
          }
        },
        className: 'form-control form-control-lg input-contract',
      },
      {
        columInput: columInput,
        campo: 'plateType',
        label: 'Tipo de plato',
        type: 'autocomplete',
        advanceOptions: {
          id: 'plateType',
          placeholder: 'Ingrese tipo de plato',
          multiple: false,
          options: props.data.tipoPlatos.filter((e: any) => e.tip_previo == 0),
        },
        onChange: async (event: any, setFieldValue: any, values: any) => {
          props.setLoad(true)
          const type = values.plateType[0]
          const t = await props.data.tipoPlatos
          if (type?.value && type?.value != '') {
            if (type.tip_previo == 0) {
              const tt: any[] = await getPlateTypesLevels(type.tip_codigo, props.data.tipoPlatos)
              tt.push(type.tip_codigo)
              setFilterPlateTypes(tt)
              props.setLoad(false)
            } else {
              const types: any[] = await props.data.tipoPlatos
                .filter((e: any) => e.tip_previo == type.tip_codigo)
                .map((e: any) => e.tip_codigo)
              setFilterPlateTypes(types)
              props.setLoad(false)
            }
          } else {
            props.setLoad(false)
          }
        },
        className: 'form-control form-control-lg input-contract',
      },
      {
        columInput: columInput,
        campo: 'tolerance',
        label: 'Intolerancia',
        type: 'autocomplete',
        advanceOptions: {
          id: 'tolerance',
          placeholder: 'Ingrese Tolerancia',
          multiple: false,
          options: props.data.intolerancias,
        },
        className: 'form-control form-control-lg input-contract',
      },
      {
        columInput: columInput,
        campo: 'allergens',
        label: 'Permite Alergenos',
        type: 'autocomplete',
        advanceOptions: {
          id: 'allergens',
          placeholder: 'Ingrese Alergenos',
          multiple: false,
          options: props.data.alergenos,
        },
        className: 'form-control form-control-lg input-contract',
      },
      {
        columInput: 2,
        campo: 'dietaryCategory',
        label: 'Categoría dietética',
        type: 'tree-select',
        style: { width: '100%' },
        treeData: propCat,
        onChangeTree: async (
          setFieldValue: any,
          values: any,
          arrayInput: any,
          currentNode: any,
          selectedNodes: any
        ) => {
        },
        className: 'bootstrap-demo w-100',
      },
      {
        columInput: columInput,
        campo: 'blockedDays',
        label: 'Días Bloqueados',
        type: 'autocomplete',
        hideInput: hideInput,
        disabled: disabledInput,
        advanceOptions: {
          id: 'blockedDays',
          placeholder: 'Dias Bloqueados',
          multiple: true,
          options: dias,
        },
        className: 'form-control form-control-lg input-contract',
      },
    ])

    if (loadData) {
      // Activar flag para evitar que onChange de fatherStructure dispare getEstructuras
      isLoadingEditRef.current = true
      props.formikProps?.setFieldValue('fatherStructure', [
        { text: data.fatherStructure, value: data.idFatherStructure },
      ])
      const structure = await getLStorage("structure")
      if (structure === "") {
        setLStorage("structure", JSON.stringify([
          { text: data.structure, value: data.idStructure },
        ]));
      }
      props.formikProps?.setFieldValue('structure', [
        { text: data.structure, value: data.idStructure },
      ])
      props.formikProps?.setFieldValue('plateType', [
        { text: data.plateType, value: data.idPlateType },
      ])
      props.formikProps?.setFieldValue('tolerance', [
        { text: data.tolerance, value: data.idTolerance },
      ])
      props.formikProps?.setFieldValue('allergens', [
        { text: data.allergens, value: data.idAllergens },
      ])
      props.formikProps?.setFieldValue('dietaryCategory', [
        { text: data.dietaryCategory, value: data.idDietaryCategory, tagLabel: data.dietaryCategoryAll },
      ])
      props.formikProps?.setFieldValue('order', data.order ? data.order : 0)

      if (data.idBlockedDays.length) {
        const d: any = onDaysSelected()
        props.formikProps?.setFieldValue('blockedDays',
          d.filter((d: any) => data.idBlockedDays.includes(d.value))
        )
      } else {
        props.formikProps?.setFieldValue('blockedDays', [])
      }

      setBtnStructure('Editar estructura')
      // Desactivar flag después de que los setFieldValue se procesen
      setTimeout(() => { isLoadingEditRef.current = false }, 300)
    }
  }

  useEffect(() => {
    if (props.reloadGrid) {
      gridRef?.current?.api?.setRowData(dataRow2)
    }
  }, [props.reloadGrid])

  const onDaysSelected = () => {
    const { monday, tuesday, wednesday, thursday, friday, saturday, sunday } =
      props.formikProps?.values
    const arrDays = [
      { text: 'Lunes', value: '1', selectable: monday },
      { text: 'Martes', value: '2', selectable: tuesday },
      { text: 'Miercoles', value: '3', selectable: wednesday },
      { text: 'Jueves', value: '4', selectable: thursday },
      { text: 'Viernes', value: '5', selectable: friday },
      { text: 'Sabado', value: '6', selectable: saturday },
      { text: 'Domingo', value: '7', selectable: sunday },
    ]

    return arrDays.filter((e: any) => e.selectable)
  }

  const getEstructuras = async (group: any) => {
    try {
      const service = props.formikProps?.values.service[0]
      if (service?.value && service?.value != '') {
        const dataEstructuras: any = await callSP('amd_getEstructuraByServicio', [
          { text: 'servicio', value: service.value.toString() },
          { text: 'agrupa_estructura', value: group },
        ])

        if (dataEstructuras.data.status != '200') {
          throw 'Error al consultar estructura por servicio!'
        }

        let arrEst: any[] = dataEstructuras.data.result.map((e: any) => {
          return {
            ...e,
            text: e.ess_nombre,
            value: e.ess_codigo.toString(),
          }
        })

        if (dataRow2.length) {
          dataRow2.forEach((e: any) => {
            let index: any = arrEst.findIndex((i: any) => i.value == e.idStructure)
            if (index != -1) {
              arrEst.splice(index, 1)
            }
          })
        }
        setEstructuras(arrEst)
      } else {
        warn('Debe seleccionar un servicio!')
      }
    } catch (e: any) {
      error(e)
    }
  }

  const clearInput = (id: string, obj: any) => {
    props.formikProps?.setFieldValue(id, [{ text: '', value: '' }])
    obj[id][0] = { text: '', value: '' }
  }

  const validateAdd = (values: any) => {
    if (!isValid(values, 'fatherStructure', 'Debe selecionar grupo estructura')) return false
    if (!isValid(values, 'structure', 'Debe selecionar estructura')) return false
    if (!isValid(values, 'plateType', 'Debe selecionar tipo de plato')) return false
    if (!isValid(values, 'tolerance', 'Debe selecionar intolerancia')) return false
    if (!isValid(values, 'allergens', 'Debe selecionar alérgenos')) return false
    if (!isValid(values, 'dietaryCategory', 'Debe selecionar categoría dietética')) return false

    if (values.blockedDays.length > 6) {
      warn('Puedes bloquear máximo 6 días')
      return false
    }

    return true
  }

  useMemo(() => {
    if (!addRow) {
      return
    }
    props.formikProps?.validateForm().then(
      (error) => {
        let obj = props.formikProps?.values
        if (validateAdd(obj)) {
          let id = dataRow2.length
          const newStore = dataRow2.slice()
          obj.id = id
          const data: contStep2 = {
            fatherStructure: obj.fatherStructure[0].text,
            idFatherStructure: obj.fatherStructure[0].value,
            structure: obj.structure[0].text,
            idStructure: obj.structure[0].value.toString(),
            allergens: obj.allergens[0].text,
            idAllergens: obj.allergens[0].value,
            dietaryCategory: obj.dietaryCategory[0].text,
            dietaryCategoryAll: obj.dietaryCategory[0].tagLabel,
            idDietaryCategory: obj.dietaryCategory[0].value,
            tolerance: obj.tolerance[0].text,
            idTolerance: obj.tolerance[0].value,
            idPlateType: obj.plateType[0].value,
            plateType: obj.plateType[0].text,
            id: id,
            data: JSON.parse(JSON.stringify(obj)),
            blockedDays:
              obj.blockedDays.length && obj.blockedDays[0].text
                ? obj.blockedDays.map((e: any) => e.text).join(',')
                : 'No aplica',
            idBlockedDays:
              obj.blockedDays.length && obj.blockedDays[0].value
                ? obj.blockedDays.map((e: any) => e.value)
                : [],
            plateTypes: filterPlateTypes,
            order: 0,
          }
          newStore.unshift(data)
          clearInput('fatherStructure', obj)
          clearInput('allergens', obj)
          clearInput('tolerance', obj)
          clearInput('dietaryCategory', obj)
          clearInput('structure', obj)
          clearInput('plateType', obj)
          setFilterPlateTypes([])
          props.formikProps?.setFieldValue('blockedDays', [])
          const mapOrder: contStep2[] = newStore.map((e: any, i: number) => {
            return {
              ...e,
              order: i,
            }
          })
          mapOrder.forEach((item: any, key: number) => { item.id = key });
          setDataRow2(mapOrder)
          gridRef?.current?.api?.setRowData(mapOrder)
        }
      },
      (success) => {
        if (success?.structure === undefined) {
          return
        }
      }
    )
  }, [open])

  const editStructure = useCallback(() => {
    setAlertChangeStructure(false);

    let obj = props.formikProps?.values
    if (validateAdd(obj)) {
      let id = dataRow2.length
      const newStore = dataRow2.slice()
      //let dtr2: any = newStore.find((e) => e.id === idGridEdit)
      let dtr2: any = newStore.find((e) => e.idStructure === idStructure && e.idFatherStructure === idFatherStructure) //idFatherStructure idStructure
      obj.id = id
      dtr2.fatherStructure = obj.fatherStructure[0].text
      dtr2.idFatherStructure = obj.fatherStructure[0].value
      dtr2.structure = obj.structure[0].text
      dtr2.idStructure = obj.structure[0].value.toString()
      dtr2.allergens = obj.allergens[0].text
      dtr2.idAllergens = obj.allergens[0].value
      dtr2.dietaryCategory = obj.dietaryCategory[0].text
      dtr2.idDietaryCategory = obj.dietaryCategory[0].value
      dtr2.tolerance = obj.tolerance[0].text
      dtr2.idTolerance = obj.tolerance[0].value
      dtr2.idPlateType = obj.plateType[0].value
      dtr2.plateType = obj.plateType[0].text
      dtr2.dietaryCategoryAll = obj.dietaryCategory[0].tagLabel
      dtr2.order = obj.order
      dtr2.id = id
      dtr2.data = JSON.parse(JSON.stringify(obj))
      dtr2.blockedDays =
        obj.blockedDays.length && obj.blockedDays[0].text
          ? obj.blockedDays.map((e: any) => e.text).join(',')
          : 'No aplica'
      dtr2.idBlockedDays =
        obj.blockedDays.length && obj.blockedDays[0].value
          ? obj.blockedDays.map((e: any) => e.value)
          : ''
      dtr2.plateTypes = filterPlateTypes.length ? filterPlateTypes : dtr2.plateTypes
      clearInput('fatherStructure', obj)
      clearInput('allergens', obj)
      clearInput('tolerance', obj)
      clearInput('dietaryCategory', obj)
      clearInput('structure', obj)
      clearInput('plateType', obj)
      setFilterPlateTypes([])
      props.formikProps?.setFieldValue('dietaryCategory', [])
      props.formikProps?.setFieldValue('blockedDays', [])
      newStore.forEach((item: any, key: number) => { item.id = key });

      setDataRow2(newStore)
      gridRef?.current?.api?.setRowData(newStore)
      setSStorage("estructura_editada", newStore)
      setTimeout(() => {
        setAlertChangeStructure(true);
      }, 400);
    }
  }, [props.formikProps?.values])

  const onDrag = useCallback((e: any, data: any) => {
    props.setLoad(true)
    let rows2: any = [];
    e.api.forEachNodeAfterFilterAndSort((node: any) => rows2.push(node.data));
    rows2.forEach((item: any, key: number) => { item.order = key; item.id = key });
    setDataRow2(rows2)
    gridRef?.current?.api?.setRowData(rows2)
    props.setLoad(false)
  }, [gridRef])
  const changeGrid = useCallback((event: any) => {

  }, [])
  return (
    <div className='w-100'>
      <div className=''>
        <h2 className='fw-bolder text-dark'>{props.title}
        </h2>
        <div className='text-gray-400 fw-bold fs-6'>{props.subTitle}
        </div>
      </div>
      <hr />
      <ArrayInput classContainer='container-input' arrayInput={arrayInput} />
      <Button
        className='btn-agregar'
        type='button'
        onClick={() => {
          if (btnStructure === 'Editar estructura') {
            setLStorage("structure", "");
            editStructure()
            if (canEditStructure) {
              setBtnStructure('Agregar estructura')
            }
          } else {
            setAlertChangeStructure(false);
            let r = !open
            setAddRow(true)
            setOpen(r)
          }
        }}
      >
        {btnStructure}
      </Button>
      <ObjectModal alertModal={alertModal} setGridRef={setGridRef} />
      <AgGridTable2 columnDefs={columnDefs} rowHeight={90} rowDrag={true} pagination={false} dataRow={dataRow2} setAGGridRef={setGridRef} onRowDrag={onDrag} />
    </div>
  )
}

StepContract2.defaultProps = {
  reloadGrid: false,
}
interface StepContract2Props {
  title?: string
  subTitle?: string
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void
  formikProps?: FormikProps<any>
  data?: any
  isReady?: boolean
  setLoad?: any
  reloadGrid?: boolean
  reloadStep2?: boolean
  editContract?: boolean
  estate?: any
}
export interface contStep2 {
  load?: boolean
  idEstRel?: number
  contrato?: string | number
  fatherStructure?: string
  idFatherStructure?: number
  tolerance?: string
  idTolerance?: number
  allergens?: string
  idAllergens?: number
  dietaryCategory?: string
  idDietaryCategory?: number
  dietaryCategoryAll?: string
  structure?: string
  idStructure?: number | string
  idStru?: number | string
  id?: number
  // allowsStamp?: string
  // idAllowsStamp?: number
  data?: [] | {}
  associatedStructure?: string
  idAssociatedStructure?: number
  blockedDays?: string | string[]
  idBlockedDays?: any[]
  plateType?: string
  idPlateType?: any
  plateTypes?: any[]
  order?: number
}
export { StepContract2 }
